exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hower1[data-v-2bd1d818]:hover{background:#c1163b;color:#fff}.hower2[data-v-2bd1d818]:hover{background:#1bbd0d;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bd1d818","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotesSaha.vue
// module id = 216
// module chunks = 0